/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import useResponse from "@/shared/hooks/useResponse";
import { useTableStoreByRoute } from "@/stores/useTableStore";
import Typography from "@mui/material/Typography";

import NoResultsFoundIcon from "../../../../../assets/customIcons/emptyTable/NoResultsFoundIcon";
import { ROUTES } from "../../../../../shared";
import Button from "../../../../Button/Button";
import { useTableStyles } from "../../../styles/styles";

interface NoResultsFoundProps {
  route: ROUTES;
}

const NoResultsFound = ({ route }: NoResultsFoundProps) => {
  const { getData } = useAxiosPrivate();
  const { handleResponse } = useResponse();
  const { t } = useTranslation();

  const { setParams, fetchData } = useTableStoreByRoute(route);

  const { noResultsIcon, emptyTableTitle, emptyTableDescription } =
    useTableStyles();

  const hideResetButton = route === ROUTES.Users;

  const handleResetView = async () => {
    // Clear filter params and reset pagination
    setParams({
      contains: null,
      filters: null,
      pageNumber: "1",
      sortedColumn: null
    });

    await fetchData(getData, handleResponse);
  };

  return (
    <>
      <div>
        <NoResultsFoundIcon
          css={css(noResultsIcon)}
          data-testid="no-results-icon"
        />
      </div>

      <Typography variant="body1Medium" css={css(emptyTableTitle)}>
        {t("Table##empty table##no results found##title")}
      </Typography>

      <Typography variant="body2Medium" css={css(emptyTableDescription)}>
        {t("Table##empty table##no results found##description")}
      </Typography>

      {!hideResetButton && (
        <Button
          variant="textOnly"
          color="primary"
          size="small"
          onClick={handleResetView}
        >
          {t("Table##empty table##button##reset view")}
        </Button>
      )}
    </>
  );
};

export default NoResultsFound;
